var map = {
	"./assignment-icon.svg": 6081,
	"./box.svg": 7789,
	"./contracts-icon.svg": 39,
	"./marketplace-icon.svg": 771,
	"./orcas-logo.svg": 4748,
	"./planner-icon.svg": 8892
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;